window.raf = window.requestAnimationFrame || function (cb) {
    return window.setTimeout(cb, 1000 / 60);
};

if (!Object.prototype.forEach) {
    Object.defineProperty(Object.prototype, 'forEach', {
        value: function (callback, thisArg) {
            if (typeof callback !== 'function') {
                throw new TypeError('Callback must be a function');
            }
            thisArg = thisArg || this;
            for (const key in this) {
                if (this.hasOwnProperty(key)) {
                    callback.call(thisArg, this[key], key, this);
                }
            }
        },
        enumerable: false,
        configurable: true,
        writable: true,
    });
}
